import Model from '@/utils/Model'
import HTTPService from '@/api/http/HTTPService'

class BulkDeliveryService extends Model {
  create (companySlug, payload) {
    return HTTPService.post(`company/${companySlug}/bulk-delivery/task`, payload)
  }

  get (companySlug) {
    return HTTPService.get(`company/${companySlug}/bulk-delivery/task`)
  }

  getTask (companySlug, task) {
    return HTTPService.get(`company/${companySlug}/bulk-delivery/task/${task}`)
  }

  getReceivers (companySlug, task, page) {
    return HTTPService.get(`company/${companySlug}/bulk-delivery/task/${task}/receiver`, {
      params: {
        page
      }
    })
  }

  delete (companySlug, task) {
    return HTTPService.delete(`company/${companySlug}/bulk-delivery/task/${task}`)
  }

  changeStatus (companySlug, task, status) {
    return HTTPService.patch(`company/${companySlug}/bulk-delivery/task/${task}`, { status })
  }

  exportReceivers (companySlug, task) {
    return HTTPService.get(`company/${companySlug}/bulk-delivery/task/${task}/export`)
  }

  importReceivers (companySlug, task, formData) {
    return HTTPService.post(`company/${companySlug}/bulk-delivery/task/${task}/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  getReport (companySlug, task) {
    return HTTPService.get(`company/${companySlug}/bulk-delivery/task/${task}/report`)
  }
}

export default new BulkDeliveryService()
